import React from "react";
import UserTable from "../../../components/UserTable";
import { getCompanyId, getOrganisationType, getUserEmail } from "../../../Authentication/Auth";

const UserSearchTable = () => {
  localStorage.setItem("UserSearchPageNumber", "0");
  const organisationName = sessionStorage.getItem("OrganisationName");
  return <UserTable
    queryParams={{
      userId: getUserEmail(),
      UserOrganisationType: getOrganisationType(),
      UserOrganisationId: Number(getCompanyId()),
      UserOrganisationName: organisationName,
    }}
    pagination="prevNext"
    cacheMechanism={true}
  />
  };

export default UserSearchTable;
